import { Box } from "@mui/material";
import Container from "components/Container";
import CustomContainer from "views/Container/CustomContainer";
import Advantages from "./Advantages";
import Teaser from "./Teaser";

const Usefull = () => {
  return (
    <CustomContainer container={false}>
      <Box>
        <Container>
          <Teaser
            imgSrc="pause.png"
            subtitle="se loger"
            imageLeft={true}
            title="Mise en relation pour se"
            titleWord="loger"
            txt="Si jamais tu souhaites te faire héberger nous avons mis à disposition un fichier excel libre d'accès permettant de mettre en relation les personnes qui souhaite héberger de celle qui souhaite un hébergement. 
            N'hésite pas à nous envoyer une demande par mail."
          />
        </Container>
      </Box>
      <Box sx={{ backgroundColor: "#cee1e0" }}>
        <Container>
          <Advantages />
        </Container>
      </Box>
      <Box>
        <Container>
          <Teaser
            imgSrc="pause2.png"
            subtitle="se restaurer"
            title="Quelques options pour se"
            titleWord="restaurer"
            txt="L’association Acro Yoga Bask proposera tout au long de l’événement de quoi se désaltérer et se régaler à petit prix : boissons, cafés, thés et gâteaux faits maison préparés avec amour par l’équipe 🌿✨
Un stand de restauration sera également présent avec de délicieux bobuns et pad thaï, disponibles en version végétarienne ou poulet 🍜"
          />
        </Container>
      </Box>
    </CustomContainer>
  );
};
export default Usefull;
